import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { getErrorAction } from '../utils/actions'
import { getMyQuestsFilterQuery } from '../utils/myquests'
import {
  setDraftFilter,
  setStatusFilter,
  setAuthorFilter,
  setAssignedToFilter,
  setKeywordFilter
} from './myquestsfilters'

export const SET_MY_QUESTS_FILTER = 'SET_MY_QUESTS_FILTER'
export const SET_MY_QUESTS_SORT = 'SET_MY_QUESTS_SORT'
export const FETCH_MY_QUESTS_REQUEST = 'FETCH_MY_QUESTS_REQUEST'
export const FETCH_MY_QUESTS_SUCCESS = 'FETCH_MY_QUESTS_SUCCESS'
export const FETCH_MY_QUESTS_FAILURE = 'FETCH_MY_QUESTS_FAILURE'
export const CLEAR_MY_QUESTS = 'CLEAR_MY_QUESTS'

export function fetchMyQuestsRequest() {
  return {
    type: FETCH_MY_QUESTS_REQUEST
  }
}

export function fetchMyQuestsSuccess(response, loadMore) {
  return {
    type: FETCH_MY_QUESTS_SUCCESS,
    payload: {
      quests: response.quests,
      page: response.meta.page,
      total: response.meta.total
    }
  }
}

export function fetchMyQuestsFailure(error) {
  return getErrorAction(FETCH_MY_QUESTS_FAILURE, error)
}

export function setMyQuestsFilter(filter) {
  return {
    type: SET_MY_QUESTS_FILTER,
    filter: filter
  }
}

export function setMyQuestsSort(sort) {
  return {
    type: SET_MY_QUESTS_SORT,
    sort: sort
  }
}

export function clearQuests() {
  return {
    type: CLEAR_MY_QUESTS
  }
}

export function setDefaultMyQuestsFilters() {
  return async (dispatch, getState) => {
    const state = getState()

    await dispatch(setDraftFilter([2]))
    await dispatch(setStatusFilter([]))
    await dispatch(setAuthorFilter([state.user.user.id]))
    await dispatch(setAssignedToFilter([]))
    await dispatch(setKeywordFilter(''))
    await dispatch(setMyQuestsFilter('drafts'))
  }
}

export function fetchMyQuests(page, clearQuestsInState) {
  return async (dispatch, getState) => {
    const state = getState()
    const query = getMyQuestsFilterQuery(state, state.organization.orgId)
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/search`

    if (clearQuestsInState) {
      dispatch(clearQuests())
    }

    dispatch(fetchMyQuestsRequest())
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            page: page,
            q: query,
            order: state.myquests.sort
          })
        })
      )
      const json = await response.json()
      dispatch(fetchMyQuestsSuccess(json))
    } catch (error) {
      dispatch(fetchMyQuestsFailure(error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/myquests.js